import React from 'react';

const Footer = () => (
  <footer className="bg-pink-100 p-4 text-center">
    <p>&copy; {new Date().getFullYear()} Salon App. All rights reserved.</p>
  </footer>
);

export default Footer;